import React from "react";
import "../../../menuPage/components/Toolbar/toolbar.css";

import Sun from "../../../../images/icons/sun.png";
import Moon from "../../../../images/icons/moon.png";
import InstagramLogo from "../../../../images/icons/instagram.png";
import LocationLogo from "../../../../images/icons/location.png";

import { useTheme } from "../../../../contexts/ThemeContext";

import { AnimatePresence, motion } from "framer-motion";

export default function MobileToolbar({ isOpen }) {
  const { toggleTheme, theme } = useTheme();
  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <motion.div
          className="menu-toolbar mobile-mode"
          key="mobile-toobar"
          initial={{
            opacity: 0,
            bottom: 0,
          }}
          animate={{
            bottom: "68px",
            opacity: 1,
          }}
          transition={{ duration: 0.4 }}
          exit={{
            bottom: 0,
            opacity: 0,
            transition: {
              duration: 0.4,
            },
          }}
        >
          <div className="menu-theme-toggler" onClick={toggleTheme}>
            {theme === "dark" ? (
              <img src={Sun} alt="" className="theme-sun-icon" />
            ) : (
              <img src={Moon} alt="" className="theme-moon-icon" />
            )}
          </div>
          <a
            className="toolbar-icon-instagram"
            href="https://instagram.com/redfoxcafe.ir?igshid=YmMyMTA2M2Y="
          >
            <img src={InstagramLogo} alt="" />
          </a>
          <a
            className="toolbar-icon-location"
            href="https://goo.gl/maps/YZuPHed7S59u1FgX6"
          >
            <img src={LocationLogo} alt="" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
